import { DashboardAreasConfiguration, WidgetAreasConfiguration } from './types'

export const defaultDashboardAreasConfiguration: DashboardAreasConfiguration = {
  currentValues: { hidden: false, position: 0 },
  widgets: { hidden: false, position: 1 },
  summary: { hidden: false, position: 2 },
  statistics: { hidden: false, position: 3 },
  savings: { hidden: false, position: 4 },
  systemLogAndMap: { hidden: false, position: 5 },
}

export const defaultWidgetAreasConfiguration: WidgetAreasConfiguration = {
  battery: { hidden: false },
  garage: { hidden: false },
  weatherForecast: { hidden: false },
  priceHistory: { hidden: false },
}

export const defaultDynamicPowerPriceWidgetAreasConfiguration: WidgetAreasConfiguration = {
  battery: { hidden: false },
  garage: { hidden: false },
  weatherForecast: { hidden: true },
  priceHistory: { hidden: false },
}

export const EDIT_SEARCH_PARAMETER = '?edit=true'
